<template>
  <div class="pt-0">
    <CurvedBottomNavigation
      :options="options"
      v-model="selected"
      foreground-color="#edf1f5"
    >
      <template #icon="{ props }">
<!--        <span-->
<!--          :class="[-->
<!--            props.icon,-->
<!--            props.icon === 'icon-home-page' ? 'p-fs-xxxl' : 'p-fs-xbig',-->
<!--          ]"-->
<!--        >-->
<!--          <span class="path1"></span>-->
<!--          <span class="path2"></span>-->
<!--          <span class="path3"></span>-->
<!--          <span class="path4"></span>-->
<!--        </span>-->
        <v-icon
          size="23pt"
          :color="props.icon === 'icon-home-page' ? 'white' : 'first'"
        >
          {{props.icon}}
        </v-icon>
      </template>
      <template #title="{ props }">
        <b class="p-fs-s">{{ props.title }}</b>
      </template>
    </CurvedBottomNavigation>
  </div>
</template>

<script>
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
import { CurvedBottomNavigation } from "bottom-navigation-vue";

export default {
  name: "TheMenu",
  components: {
    CurvedBottomNavigation,
  },
  data() {
    return {
      alert,
      label,

      selected: 1,
      options: [
        {
          id: 3,
          icon: "mdi-folder-outline",
          title: "اداری",
          path: { name: "HR" },
        },
        {
          id: 2,
          icon: "mdi-hammer-wrench",
          title: "پشتیبانی",
          path: { name: "Support" },
        },
        {
          id: 1,
          icon: "mdi-home-outline",
          title: "خانه",
          path: { name: "MainContainer" },
        },
        {
          id: 4,
          icon: "mdi-cash-register",
          title: "مالی",
          path: { name: "Finance" },
        },
        {
          id: 5,
          icon: "mdi-account",
          title: "کارمند",
          path: { name: "User" },
        },
      ],
    };
  },
};
</script>
<style lang="sass">
.checked .active-label
    background-image: linear-gradient(to bottom, #DF2935 0%, #bf0008 81%, #DF2935 100%) !important
    box-shadow: #bf5e5f 0px 5px 15px
    i
        &::before
            color: #ffdcd4
.checked .btn-title
  color: #FF5644 !important
.unchecked .btn-title
  color: #202323 !important

  
</style>
